import React from "react";
import { Quote } from "lucide-react";
import { TESTIMONIALS } from "../mock";

export default function Testimonials() {
  return (
    <section className="bg-[#fdfaf7]">
      <div className="max-w-7xl mx-auto px-5 py-16">
        <h2 className="font-display text-3xl sm:text-4xl text-[#1f1a1b] text-center">Loved by families across the US</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mt-12">
          {TESTIMONIALS.map((t) => (
            <div key={t.name} className="rounded-2xl border border-black/[0.07] bg-white p-7 flex flex-col">
              <Quote className="w-8 h-8 text-[#e6b9c1]" />
              <p className="text-[15px] text-[#3a3436] leading-relaxed mt-3 flex-1">“{t.quote}”</p>
              <div className="flex items-center gap-3 mt-6 pt-5 border-t border-black/[0.06]">
                <img src={t.avatar} alt={t.name} className="w-11 h-11 rounded-full object-cover" />
                <div>
                  <p className="text-[15px] font-semibold text-[#1f1a1b] leading-tight">{t.name}</p>
                  <p className="text-[13px] text-[#8a8285]">{t.city}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
